import React from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { API_KEY } from '../../constants';
import './HouseDetails.css';
import * as myConst from '../../constants.js';
import { getDriveImage } from '../../helpers/getDriveImage.js';

function HouseDetails() {
  const [house, setHouse] = React.useState([]);
  const [avatar, setAvatar] = React.useState();
  const [images, setImages] = React.useState([]);
  const [copied, setCopied] = React.useState(false);

  const params = useParams();

  React.useEffect(() => {
    if (params.id) {
      const sheet = params.id;
      const avatarData = {
        img: myConst.BASE_URL + '/img/avatar.png',
        whatsapp: '',
        email: '',
        phone: '',
        facebook: '',
        calendarApi: '',
        text: '',
        title: '',
        textoBoton: 'Contactar',
      };

      axios
        .get(
          `https://sheets.googleapis.com/v4/spreadsheets/1FyBkFmdLO8BeNdmDohYRvAh_nJP1jsdsEZ_rPYm8m1s/values/${sheet}?key=${API_KEY}`
        )
        .then((res) => {
          const values = res.data.values;
          sliderImg(values);
          
          // Extraer datos del avatar ANTES de hacer shift (con encabezados incluidos)
          if (values[101]?.[1]) {
            const avatarImg = getDriveImage(values[101][1]);
            if (avatarImg) avatarData.img = avatarImg;
          }
          
          avatarData.text = values[96]?.[1] || '';
          avatarData.title = values[97]?.[1] || '';
          avatarData.textoBoton = values[102]?.[1] || 'Contactar';
          
          setAvatar(avatarData);
          
          values.shift(); // quitar encabezados
          console.log("values",values)
          setHouse(values);
        })
        .catch(() => {
          // en error al menos deja house vacío para mostrar "Cargando..."
          setHouse([]);
        });
    }
  }, [params.id]);

  const handleContact = (phone) => {
    window.open(`https://wa.me/${house[98][1]}?text=${encodeURIComponent(
      `Quiero más información sobre la propiedad \n${shareTitle}`
    )}`, '_blank');
  }

  // Galería principal (col 5, desde fila 22)
  const sliderImg = (data) => {
    let i = 22;
    const aux = [];
    while (data[i] && data[i][5]) {
      const t = getDriveImage(data[i][5]);
      if (t) aux.push(t);
      else break;
      i++;
    }
    setImages(aux);
  };

  // --- Modal State & handlers ---
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);

  const openModal = (index) => {
    setSelectedImageIndex(index);
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);
  const showNextImage = () =>
    setSelectedImageIndex((prev) => (prev + 1) % images.length);
  const showPrevImage = () =>
    setSelectedImageIndex((prev) => (prev - 1 + images.length) % images.length);

  // Precio (si luego quieres dar formato, hazlo aquí)
  const formatPrice = (price) => price;

  // Características
  const getHouseFeatures = () => {
    const f = [];
    if (house[21]?.[7]) f.push(house[21][7]);
    if (house[22]?.[7]) f.push(house[22][7]);
    if (house[23]?.[7]) f.push(house[23][7]);
    if (house[24]?.[7]) f.push(house[24][7]);
    if (house[25]?.[7]) f.push(house[25][7]);
    if (house[26]?.[7]) f.push(house[26][7]);
    if (house[27]?.[7]) f.push(house[27][7]);
    if (house[28]?.[7]) f.push(house[28][7]);
    if (house[29]?.[7]) f.push(house[29][7]);
    if (house[30]?.[7]) f.push(house[30][7]);
    return f;
  };

  // Tabla dinámica de distribución (house[22-44])
  const getDynamicTable = React.useMemo(() => {
    if (!house[22]) return null;

    // Mapear qué columna pertenece a cada header
    const columnMapping = {};
    const columns = [];
    
    for (let i = 22; i <= 44; i++) {
      const colValue = house[i]?.[2];
      if (colValue && colValue.trim() !== '') {
        if (!columnMapping[colValue]) {
          columnMapping[colValue] = [];
          columns.push(colValue);
        }
        columnMapping[colValue].push(i);
      }
    }

    if (columns.length === 0) return null;

    // Crear filas con datos
    const rows = [];
    const processedRows = new Set();

    for (let i = 22; i <= 44; i++) {
      const rowLabel = house[i]?.[0];
      if (!rowLabel || rowLabel.trim() === '' || processedRows.has(rowLabel)) continue;

      const rowData = { label: rowLabel, values: {} };
      let hasValidValue = false;

      // Para cada columna, buscar el valor en la fila correspondiente
      columns.forEach((col) => {
        // Buscar en todas las filas que pertenecen a esta columna
        const rowsForColumn = columnMapping[col];
        const matchingRow = rowsForColumn.find(rowIdx => house[rowIdx]?.[0] === rowLabel);
        
        if (matchingRow !== undefined) {
          const cellValue = house[matchingRow]?.[1];
          // Solo agregar si no es 'X' y no está vacío
          if (cellValue && cellValue.trim() !== '' && cellValue.toUpperCase() !== 'X') {
            rowData.values[col] = cellValue;
            hasValidValue = true;
          }
        }
      });

      // Solo agregar la fila si tiene al menos un valor válido
      if (hasValidValue) {
        rows.push(rowData);
        processedRows.add(rowLabel);
      }
    }

    return rows.length > 0 ? { columns, rows } : null;
  }, [house]);

  // --- Share (usa share.php para tarjetas correctas) ---
  const shareUrl = `https://residenciales.yodesarrollo.mx/share.php?id=${encodeURIComponent(
    params.id
  )}`;
  const shareTitle = `${params.id} - YoDesarrollo Residencial`;
  const shareText = `Mira esta propiedad: ${params.id}`;
  const waHref = `https://wa.me/?text=${encodeURIComponent(
    `${shareTitle}\n${shareUrl}`
  )}`;
  const fbHref = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    shareUrl
  )}`;

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: shareTitle, text: shareText, url: shareUrl });
      } catch (_) {}
    } else {
      await handleCopyLink();
    }
  };
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      window.prompt('Copia este enlace:', shareUrl);
    }
  };

  // Clase utilitaria para los icon-buttons
  const iconBtn =
    'h-10 w-10 sm:h-11 sm:w-11 rounded-full flex items-center justify-center shadow ring-1 ring-black/5 hover:scale-105 active:scale-95 transition';

  if (house.length === 0) return <div>Cargando...</div>;

  const allDesc =  params.id.split(',')
  const title = params.id.split(',')[0]
  let description = params.id.split(',')[1]
  for (let i = 1; i < allDesc.length; i++) {
    description += `, ${allDesc[i]}`
  }

  const back = () => {
    window.history.back();
  }

  return (
    <>
      <Helmet>
        <title>{`${params.id}, - YoDesarrollo Residencial`}</title>
        <meta
          name="description"
          content={`Casa en venta. ${house[1]?.[3] || '-'} recámaras, ${
            house[2]?.[1] || '-'
          } baños, ${house[3]?.[1] || '-'} m². Acabados de lujo y amenidades exclusivas.`}
        />

        {/* Open Graph Meta Tags (para cuando alguien pega esta URL directamente) */}
        <meta property="og:title" content={`${params.id}, - YoDesarrollo Residencial`} />
        <meta
          property="og:description"
          content={`Casa en venta. ${house[1]?.[1] || '-'} recámaras, ${
            house[2]?.[1] || '-'
          } baños, ${house[3]?.[1] || '-'} m². Precio: ${formatPrice(
            house[0]?.[1]
          )}`}
        />
        <meta
          property="og:image"
          content={
            images[0] || 'https://placehold.co/1200x800/0A2342/FFFFFF?text=Fachada+Principal'
          }
        />
        <meta
          property="og:url"
          content={`https://residenciales.yodesarrollo.mx/${encodeURIComponent(params.id)}`}
        />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${params.id}, - YoDesarrollo Residencial`} />
        <meta
          name="twitter:description"
          content={`Casa en venta. ${house[1]?.[1] || '-'} recámaras, ${
            house[2]?.[1] || '-'
          } baños, ${house[3]?.[1] || '-'} m². Precio: ${formatPrice(
            house[0]?.[1]
          )}`}
        />
        <meta
          name="twitter:image"
          content={
            images[0] || 'https://placehold.co/1200x800/0A2342/FFFFFF?text=Fachada+Principal'
          }
        />
      </Helmet>

      <div className="min-h-screen bg-gray-50 container">
        <main className="mx-auto px-6 py-12 max-w-7xl">
          <div className="flex justify-between items-start sm:items-center gap-4 flex-wrap">
            <div className="mb-2">
              <h1 className="text-3xl sm:text-4xl font-bold text-blue-900 mb-2 break-words">
                { title }
              </h1>
              <p className="text-lg text-gray-600 flex items-center">
                <i className="fas fa-map-marker-alt mr-2 text-blue-900"></i>
                { description }
              </p>
            </div>

            {/* Botonera de compartir (solo íconos, responsive) */}
            <div className="flex items-center gap-2 sm:gap-3">
              {/* Share nativo */}
              <button
                onClick={handleNativeShare}
                className={`${iconBtn} bg-blue-900 text-white`}
                aria-label="Compartir"
                title="Compartir"
              >
                <svg viewBox="0 0 24 24" className="h-5 w-5">
                  <path
                    fill="currentColor"
                    d="M18 16a3 3 0 0 0-2.24 1.03L8.91 13.7a3.06 3.06 0 0 0 0-3.4l6.85-3.33A3 3 0 1 0 15 5a2.98 2.98 0 0 0 .05.54L8.2 8.9a3 3 0 1 0 0 6.2l6.85 3.36A3 3 0 1 0 18 16Z"
                  />
                </svg>
              </button>

              {/* WhatsApp */}
              <a
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                className={`${iconBtn} bg-[#25D366] text-white`}
                aria-label="WhatsApp"
                title="WhatsApp"
              >
                <svg viewBox="0 0 24 24" className="h-5 w-5">
                  <path
                    fill="currentColor"
                    d="M20.5 3.5A11 11 0 0 0 3.6 18.9L3 22l3.2-.8A11 11 0 1 0 20.5 3.5m-8.3 16a9 9 0 0 1-4.5-1.2l-.3-.2l-2 .5l.5-2l-.2-.3a9 9 0 1 1 6.5 3.2m5-6.8c-.3-.1-1.8-.9-2.1-1s-.5-.1-.7.1c-.2.3-.8 1-.9 1.1c-.2.2-.3.2-.6.1c-.3-.1-1.1-.4-2.1-1.3c-.8-.7-1.3-1.6-1.5-1.8c-.1-.3 0-.4.1-.5l.4-.5c.2-.2.2-.3.3-.5c.1-.2 0-.4 0-.5c0-.1-.7-1.7-1-2.3c-.3-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.7.3c-.2.3-.9.9-.9 2.2c0 1.3.9 2.5 1 2.6c.1.2 1.8 2.8 4.4 3.9c.6.3 1.1.4 1.5.6c.6.2 1.1.2 1.5.1c.5-.1 1.8-.7 2-1.3c.2-.6.2-1.1.1-1.2c-.1-.1-.3-.2-.6-.3Z"
                  />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href={fbHref}
                target="_blank"
                rel="noopener noreferrer"
                className={`${iconBtn} bg-[#1877F2] text-white`}
                aria-label="Facebook"
                title="Facebook"
              >
                <svg viewBox="0 0 24 24" className="h-5 w-5">
                  <path
                    fill="currentColor"
                    d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2.4V12h2.4V9.8c0-2.4 1.4-3.7 3.5-3.7c1 0 2 .2 2 .2v2.3h-1.1c-1.1 0-1.5.7-1.5 1.4V12h2.6l-.4 2.9H13.3v7A10 10 0 0 0 22 12Z"
                  />
                </svg>
              </a>

              {/* Copiar */}
              <button
                onClick={handleCopyLink}
                className={`${iconBtn} bg-white text-gray-700`}
                aria-label="Copiar enlace"
                title="Copiar enlace"
              >
                {copied ? (
                  <svg viewBox="0 0 24 24" className="h-5 w-5 text-green-600">
                    <path
                      fill="currentColor"
                      d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
                    />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" className="h-5 w-5">
                    <path
                      fill="currentColor"
                      d="M16 1H4a2 2 0 0 0-2 2v12h2V3h12zm3 4H8a2 2 0 0 0-2 2v14l4-4h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z"
                    />
                  </svg>
                )}
              </button>
              <button className="back-button" onClick={() => back()}>
                ← Regresar
              </button>
            </div>
          </div>

          {/* Galería */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-12">
            <div className="lg:col-span-2">
              <img
                src={
                  images[0] ||
                  'https://placehold.co/1200x800/0A2342/FFFFFF?text=Fachada+Principal'
                }
                onError={(e) => {
                  e.currentTarget.src =
                    'https://placehold.co/1200x800/0A2342/FFFFFF?text=Fachada+Principal';
                }}
                alt="Fachada de la casa"
                className="w-full h-80 lg:h-96 object-cover rounded-lg shadow-lg cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openModal(0)}
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              {images.slice(1, 5).map((img, index) => (
                <div
                  key={index}
                  className="relative w-full h-36 lg:h-full bg-gray-800 rounded-lg shadow-lg flex items-center justify-center cursor-pointer group"
                  onClick={() => openModal(index + 1)}
                >
                  <img
                    src={img}
                    onError={(e) => {
                      e.currentTarget.src =
                        'https://placehold.co/600x400/94A3B8/FFFFFF?text=Imagen';
                    }}
                    alt={`Vista ${index + 2}`}
                    className="w-full h-full object-cover rounded-lg group-hover:opacity-90 transition-opacity"
                  />
                  {index === 3 && images.length > 5 && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
                      <span className="text-white text-xl font-bold">
                        +{images.length - 5} Fotos
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Detalles */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
            <div className="border-b-2 border-gray-200 pb-6 mb-6">
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
    {/* Precio */}
    <div>
      <p className="text-gray-500 text-sm mb-1">{house[35][4]}</p>
      <p className="text-xl sm:text-2xl font-medium text-gray-400 line-through">
        {formatPrice(house[35][5])}
      </p>
      <p className="text-gray-500 text-sm mt-2 mb-1">
        {house[1][2] || 'Precio actual'}
      </p>
      <p className="text-3xl sm:text-4xl font-bold text-blue-900">
        {formatPrice(house[1][3])}
      </p>
    </div>

    {/* Stats: en móvil se acomoda abajo en grilla; en sm+ va a la derecha */}
    <div className="w-full sm:w-auto grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 text-center">
      <div className="flex flex-col items-center">
        <i className="fas fa-bed text-2xl sm:text-3xl text-blue-900 mb-1"></i>
        <p className="font-semibold">{house[43][1] || '-'} Rec.</p>
      </div>
      <div className="flex flex-col items-center">
        <i className="fas fa-bath text-2xl sm:text-3xl text-blue-900 mb-1"></i>
        <p className="font-semibold">{house[44][1] || '-'} Baños</p>
      </div>
      <div className="flex flex-col items-center">
        <i className="fas fa-ruler-combined text-2xl sm:text-3xl text-blue-900 mb-1"></i>
        <p className="font-semibold">{house[42][5] || '-'} m²</p>
      </div>
      <div className="flex flex-col items-center">
        <i className="fas fa-car text-2xl sm:text-3xl text-blue-900 mb-1"></i>
        <p className="font-semibold">{house[41][2] || '-'} Autos</p>
      </div>
    </div>
  </div>
</div>

              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Descripción</h2>
                <p className="text-gray-600 leading-relaxed">
                  {house[73][1] ||
                    `Descubre la elegancia y el confort en el modelo ${params.id}, ubicado en el prestigioso residencial Altozano. Esta propiedad cuenta con acabados de lujo, espacios amplios y una distribución inteligente pensada para el disfrute de toda la familia. La cocina de concepto abierto se integra perfectamente con la sala y el comedor, creando un ambiente ideal para convivir. Disfruta de atardeceres espectaculares desde tu terraza y vive rodeado de seguridad y amenidades de primer nivel.`}
                </p>
              </div>

              {/* Tabla dinámica de distribución */}
              {getDynamicTable && (
                <div className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-800 mb-2">
                    {house[20]?.[0] || 'Distribución'}
                  </h2>
                  {house[21]?.[0] && house[21]?.[1] && (
                    <p className="text-gray-600 mb-4">
                      <strong>{house[21][0]}</strong> {house[21][1]}
                    </p>
                  )}
                  <div className="overflow-x-auto shadow-md rounded-lg">
                    <table className="min-w-full bg-white border-collapse">
                      <thead>
                        <tr className="bg-blue-900 text-white">
                          <th className="px-6 py-4 text-left font-semibold border-b-2 border-blue-700">
                            Característica
                          </th>
                          {getDynamicTable.columns.map((col, idx) => (
                            <th key={idx} className="px-6 py-4 text-center font-semibold border-b-2 border-blue-700">
                              {col}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {getDynamicTable.rows.map((row, rowIdx) => (
                          <tr 
                            key={rowIdx} 
                            className={`${rowIdx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-blue-50 transition-colors`}
                          >
                            <td className="px-6 py-3 border-b border-gray-200 font-medium text-gray-800">
                              {row.label}
                            </td>
                            {getDynamicTable.columns.map((col, colIdx) => (
                              <td key={colIdx} className="px-6 py-3 border-b border-gray-200 text-center text-gray-600">
                                {row.values[col] || '-'}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  Características Principales
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-gray-700">
                  {getHouseFeatures().map((feature, index) => (
                    <span key={index} className="flex items-center">
                      <i className="fas fa-check-circle text-green-500 mr-2" />
                      {feature}
                    </span>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Ubicación</h2>
                <div className="bg-gray-200 rounded-lg h-80 flex items-center justify-center">
                  {
                    <iframe
                      src={house[45][5]}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Mapa"
                    />
                  }
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white p-8 rounded-lg shadow-xl lg:sticky lg:top-32">
                <h3 className="text-2xl font-bold text-center mb-6">
                  ¿Interesado? ¡Contáctanos!
                </h3>
                <div className="flex items-center mb-6">
                  <img
                    src={avatar?.img || 'https://placehold.co/100x100/0A2342/FFFFFF?text=AG'}
                    onError={(e) => {
                      e.currentTarget.src = 'https://placehold.co/100x100/0A2342/FFFFFF?text=AG';
                    }}
                    alt="Foto del agente"
                    className="w-20 h-20 rounded-full mr-4 object-cover"
                  />
                  <div>
                    <p className="font-bold text-lg">{avatar?.title || 'Asesor'}</p>
                    <p className="text-gray-600">{avatar?.text || ''}</p>
                  </div>
                </div>
                <button
                  type="button"
                  className="w-full bg-blue-900 text-white p-4 rounded-lg font-bold text-lg hover:bg-blue-800 transition-colors"
                  onClick={() => handleContact()}
                >
                  {avatar?.textoBoton || 'Contactar'}
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* --- Image Modal --- */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="relative max-w-4xl max-h-4/5 p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={images[selectedImageIndex]}
              alt="Visor de imagen"
              className="max-h-[80vh] w-auto rounded-lg"
              onError={(e) => {
                e.currentTarget.src =
                  'https://placehold.co/1200x800/0A2342/FFFFFF?text=Fachada+Principal';
              }}
            />
            <button
              onClick={closeModal}
              className="absolute -top-4 -right-4 bg-white text-black rounded-full h-10 w-10 flex items-center justify-center text-2xl font-bold"
            >
              &times;
            </button>

            <button
              onClick={showPrevImage}
              className="absolute left-0 top-1/2 -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 text-black rounded-full h-12 w-12 flex items-center justify-center text-3xl ml-4"
            >
              &#8249;
            </button>

            <button
              onClick={showNextImage}
              className="absolute right-0 top-1/2 -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 text-black rounded-full h-12 w-12 flex items-center justify-center text-3xl mr-4"
            >
              &#8250;
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default HouseDetails;
